module.exports = __webpack_public_path__ + "prod/1.42.2/img/professional.3976a25d.png";